import type { UserAuthDto, UserDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto[]>({
      method: 'GET',
      url: '/api/app/user',
    },
    { apiName: this.apiName,...config });
  

  getByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserAuthDto>({
      method: 'GET',
      url: '/api/app/user/by-email',
      params: { email },
    },
    { apiName: this.apiName,...config });
  

  getByUsername = (username: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto[]>({
      method: 'GET',
      url: '/api/app/user/by-username',
      params: { username },
    },
    { apiName: this.apiName,...config });
  

  getByVendor = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto[]>({
      method: 'GET',
      url: `/api/app/user/by-vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });
}